<ng-container [formGroup]="model">
  Tekst:
  <textarea formControlName="text"></textarea>

  <div class="options">
    Wyrównanie tekstu w pionie
    <div class="options">
      <lib-button
        [ngClass]="{
          picked: model.value.verticalAlign === 'top'
        }"
        icon-only
        (click)="
          model.patchValue({
            verticalAlign: 'top'
          })
        "
      >
        <mat-icon>align_vertical_top</mat-icon>
      </lib-button>
      <lib-button
        icon-only
        [ngClass]="{
          picked: model.value.verticalAlign === 'center'
        }"
        (click)="
          model.patchValue({
            verticalAlign: 'center'
          })
        "
      >
        <mat-icon> align_vertical_center </mat-icon>
      </lib-button>
      <lib-button
        icon-only
        [ngClass]="{
          picked: model.value.verticalAlign === 'bottom'
        }"
        (click)="
          model.patchValue({
            verticalAlign: 'bottom'
          })
        "
      >
        <mat-icon> align_vertical_bottom </mat-icon>
      </lib-button>
    </div>
    <div class="colorPicker">
      Kolor tła:
      <input
        #me
        (colorPickerChange)="model.controls.background.patchValue($event)"
        [(colorPicker)]="model.value.background"
        [style.background]="me.value ? me.value : model.value.background"
        cpPosition="auto"
        [cpUseRootViewContainer]="true"
      />
    </div>
    <div>
      <app-change-number formControlName="padding" [minNumber]="0" step="5"
        >Marginesy wewnętrzne</app-change-number
      >
    </div>
    <div>
      <app-change-number formControlName="borderRadius" [minNumber]="0"
        >Zaokrąglone rogi</app-change-number
      >
    </div>
    <!--    <mat-accordion>-->
    <!--      <mat-expansion-panel>-->
    <!--        <mat-expansion-panel-header>-->
    <!--          <mat-panel-title> Paragraf </mat-panel-title>-->
    <!--        </mat-expansion-panel-header>-->
    <div>
      Wyrównanie tekstu w poziomie
      <div class="options">
        <lib-button
          [ngClass]="{
            picked: model.value.align === 'left'
          }"
          icon-only
          (click)="
            model.patchValue({
              align: 'left'
            })
          "
        >
          <mat-icon>format_align_left</mat-icon>
        </lib-button>
        <lib-button
          [ngClass]="{
            picked: model.value.align === 'center'
          }"
          icon-only
          (click)="
            model.patchValue({
              align: 'center'
            })
          "
        >
          <mat-icon>format_align_center</mat-icon>
        </lib-button>
        <lib-button
          icon-only
          [ngClass]="{
            picked: model.value.align === 'right'
          }"
          (click)="
            model.patchValue({
              align: 'right'
            })
          "
        >
          <mat-icon>format_align_right</mat-icon>
        </lib-button>
      </div>

      <lib-font-inline-picker formControlName="font"
        >Czcionka:</lib-font-inline-picker
      >
      <div class="options">
        Rozmiar czcionki
        <div>
          <mat-slider
            min="10"
            max="400"
            step="1"
            discrete
          ><input matSliderThumb formControlName="fontSize" /></mat-slider>
        </div>
      </div>
      <div class="options">
        Odstęp między literami
        <div>
          <mat-slider
            min="-1"
            max="2"
            step="0.01"
            discrete
          ><input matSliderThumb formControlName="fontLatterSpacing" /></mat-slider>
        </div>
      </div>
      <div class="colorPicker">
        Kolor:
        <input
          #me
          (colorPickerChange)="model.controls.color.patchValue($event)"
          [(colorPicker)]="model.value.color"
          [style.background]="me.value ? me.value : model.value.color"
          cpPosition="auto"
          [cpUseRootViewContainer]="true"
        />
      </div>
      <lib-checkbox formControlName="uppercase">
        Tekst wielkimi literami
      </lib-checkbox>
    </div>
    <!--      </mat-expansion-panel>-->
    <!--      <mat-expansion-panel>-->
    <!--        <mat-expansion-panel-header>-->
    <!--          <mat-panel-title> Nagłówek </mat-panel-title>-->
    <!--        </mat-expansion-panel-header>-->
    <!--        <div>-->
    <!--          Wyrównanie tekstu w poziomie-->
    <!--          <div class="options">-->
    <!--            <lib-button-->
    <!--              [ngClass]="{-->
    <!--                picked: model.value.headerAlign === 'left'-->
    <!--              }"-->
    <!--              icon-only-->
    <!--              (click)="-->
    <!--                model.patchValue({-->
    <!--                  headerAlign: 'left'-->
    <!--                })-->
    <!--              "-->
    <!--            >-->
    <!--              <mat-icon>format_align_left</mat-icon>-->
    <!--            </lib-button>-->
    <!--            <lib-button-->
    <!--              [ngClass]="{-->
    <!--                picked: model.value.headerAlign === 'center'-->
    <!--              }"-->
    <!--              icon-only-->
    <!--              (click)="-->
    <!--                model.patchValue({-->
    <!--                  headerAlign: 'center'-->
    <!--                })-->
    <!--              "-->
    <!--            >-->
    <!--              <mat-icon>format_align_center</mat-icon>-->
    <!--            </lib-button>-->
    <!--            <lib-button-->
    <!--              icon-only-->
    <!--              [ngClass]="{-->
    <!--                picked: model.value.headerAlign === 'right'-->
    <!--              }"-->
    <!--              (click)="-->
    <!--                model.patchValue({-->
    <!--                  headerAlign: 'right'-->
    <!--                })-->
    <!--              "-->
    <!--            >-->
    <!--              <mat-icon>format_align_right</mat-icon>-->
    <!--            </lib-button>-->
    <!--          </div>-->

    <!--          <lib-font-inline-picker formControlName="headerFont"-->
    <!--            >Czcionka:</lib-font-inline-picker-->
    <!--          >-->

    <!--          <div class="options">-->
    <!--            Rozmiar czcionki-->
    <!--            <div>-->
    <!--              <mat-slider-->
    <!--                min="10"-->
    <!--                max="400"-->
    <!--                step="1"-->
    <!--                thumbLabel-->
    <!--                formControlName="headerFontSize"-->
    <!--              ></mat-slider>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="options">-->
    <!--            Odstęp między literami-->
    <!--            <div>-->
    <!--              <mat-slider-->
    <!--                min="-1"-->
    <!--                max="2"-->
    <!--                step="0.01"-->
    <!--                thumbLabel-->
    <!--                formControlName="headerFontLatterSpacing"-->
    <!--              ></mat-slider>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="colorPicker">-->
    <!--            Kolor:-->
    <!--            <input-->
    <!--              #me-->
    <!--              (colorPickerChange)="-->
    <!--                model.controls.headerColor.patchValue($event)-->
    <!--              "-->
    <!--              [(colorPicker)]="model.value.headerColor"-->
    <!--              [style.background]="me.value ? me.value : model.value.headerColor"-->
    <!--              cpPosition="auto"-->
    <!--              [cpUseRootViewContainer]="true"-->
    <!--            />-->
    <!--          </div>-->
    <!--          <lib-checkbox formControlName="headerUppercase">-->
    <!--            Tekst wielkimi literami-->
    <!--          </lib-checkbox>-->
    <!--        </div>-->
    <!--      </mat-expansion-panel>-->
    <!--    </mat-accordion>-->
  </div>
</ng-container>
